const { Mixin } = require('@xingternal/hops');
const selectVariantName = require('./../../src/utils/selectVariantName');

const experiment = {
  name: 'REG-6931',
  variantsVector: ['a', 'b', 'c'],
};

class FormRuntimeMixin extends Mixin {
  enhanceServerData(serverData, _req, res) {
    let enhancedServerData = {
      ...serverData,
      language: res.locals.language,
      experiment: {},
    };

    if (!res.locals.loginFormState) return enhancedServerData;

    const {
      attemptedUsername,
      authPartner,
      knownUser,
      notice,
      error,
    } = res.locals.loginFormState;

    let selectedVariantName = null;
    if (knownUser) {
      selectedVariantName = selectVariantName(
        experiment.name,
        knownUser.hashedId,
        experiment.variantsVector
      );
    }

    const formMessage = {
      notice,
      error,
    };

    return {
      ...enhancedServerData,
      attemptedUsername,
      authPartner,
      formMessage,
      knownUser,
      experiment: {
        ...experiment,
        selectedVariantName,
      },
    };
  }
}

module.exports = FormRuntimeMixin;
